import React, { useEffect, useState } from "react";
import { Loading } from "../Other/Loading";
import axiosInstance from "../../axios";
import {
  courseViewTypes,
  courseSortOptionsSubjects,
  courseSortOptionsSkillLevel,
  courseSortOptionsMostRelevant,
  courseSortOptionsLearningType,
  courseSortOptionsAvailability,
} from "../../_constants/staticData";
import CourseTile from "./CourseTile/CourseTile";
import { SearchBar } from "../Other/Search/Search";
import { useLocation } from "react-router";

export const Courses = ({
  courses,
  title,
  varient,
  setSelectedCourses,
  total,
  isFetching,
  handlefilterChange,
  Filter,
  setFilter,
  bundle,
}) => {
  const { REACT_APP_LOGIN_API_BASEURL } = process.env;
  const location = useLocation();
  const { category, subCategory, level } = location?.state || {};
  const [viewType, setViewType] = useState("tile");
  const [categoryData, setCategoryData] = useState([]);
  const [subCategoryData, setSubcategoryData] = useState([]);
  // Sort by created date
  const sortByCreatedDate = (a, b) =>
    new Date(b.CreatedOn) - new Date(a.CreatedOn);

  // Sort by highest rated
  const sortByHighestRated = (a, b) => b.StarRating - a.StarRating;

  // Sort course handle
  const handleSortCourses = (sortBy) => {
    const courseData = [...courses];
    switch (sortBy) {
      case "rated":
        setSelectedCourses(courseData.sort(sortByHighestRated));
        break;
      case "latest":
        setSelectedCourses(courseData.sort(sortByCreatedDate));
        break;
      default:
        setSelectedCourses(courseData);
    }
  };

  const handleCourseView = (sortType) => {
    setViewType(sortType);
  };

  const handleFilterSubCategory = () => {
    if (categoryData?.length > 0) {
      const subCategory = categoryData.filter(
        (category) =>
          category.parent_category?.toLowerCase() ===
          Filter?.fliterCategory?.toLowerCase()
      );
      if (subCategory?.length > 0) {
        setSubcategoryData(subCategory[0]?.child_categories);
      }
    }
  };

  const fetchCategories = async () => {
    try {
      const res = await axiosInstance.get(`${REACT_APP_LOGIN_API_BASEURL}/categories?tags=1&filter=1`);
      setCategoryData(res?.data?.data);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  useEffect(() => {
    if (categoryData?.length > 0) {
      handleFilterSubCategory();
    }
  }, [Filter]);

  useEffect(() => {
    if (categoryData?.length > 0) {
      // setFilter({
      //   fliterCategory: category,
      //   filterSubCategory: subCategory,
      //   fliterLevel: level,
      // });
    }
  }, [categoryData]);

  return (
    <div className="courseList">
      <div>
        <div className="content margin-top-new-40">
          <div className="bg-color-courselist">
            <div className="inner-wrapper">
              <div className="course-page-title">
                {title}
                <span className="total-courses-courselist">
                  {bundle
                    ? `${courses?.bundleCourses?.length === 0
                      ? "..."
                      : courses?.bundleCourses?.length
                    } Bundles in yslearn`
                    : `${total === undefined ? "..." : total
                    } courses in yslearn`}
                </span>
              </div>

              <div className="top-wrapper">
                <div
                  className={`search-wrapper ${varient === "courses" ? "courses" : ""
                    }`}
                >
                  <SearchBar Filter={Filter} setFilter={setFilter} />
                </div>

                <div className="sort-wrapper custom1">
                  {courseViewTypes?.map((sort) => {
                    return (
                      <i
                        key={sort.key}
                        className={`${sort.icon} ${sort.type === viewType ? "active" : ""
                          }`}
                        onClick={() => handleCourseView(sort.type)}
                      ></i>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
          {!bundle && (
            <div className="bg-course-bg-color">
              <div className="inner-wrapper">
                <div className="course-page-title">
                  {bundle ? "Sort Bundles" : "Sort Courses"}
                </div>
                {categoryData?.length > 0 ? (
                  <div>
                    <div className="sort-wrapper">
                      <div className="sort-dropdown">
                        <select
                          aria-label="sortDropdown"
                          name="fliterCategory"
                          onChange={handlefilterChange}
                          value={Filter?.fliterCategory}
                        >
                          <option value="" hidden>
                            All Courses
                          </option>
                          {categoryData?.map((sort, index) => (
                            <option key={index} value={sort.parent_category}>
                              {sort.parent_category}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="sort-dropdown" id="filter-subcategory">
                        <select
                          aria-label="sortDropdown"
                          onChange={handlefilterChange}
                          name="filterSubCategory"
                          value={Filter?.filterSubCategory}
                        >
                          <option key="" value="">
                            All
                          </option>
                          <option key="" value="Popular">
                            Popular
                          </option>
                          {subCategoryData?.map((subCategory, index) => (
                            <option key={index} value={subCategory.name}>
                              {subCategory.name}
                            </option>
                          ))}
                        </select>
                      </div>

                      {/* <div className="sort-dropdown disabledSelectDropdown">
                      <select
                        aria-label="sortDropdown"
                        // onChange={(e) =>
                        //   handleSortCourses(e.target.value, courses)
                        // }

                        disabled={true}
                      >
                        <option value="" hidden>
                          Price Range
                        </option>
                        {price.map((sort, index) => (
                          <option key={index} value={sort}>
                            {sort}
                          </option>
                        ))}
                      </select>
                    </div> */}

                      <div className="sort-dropdown ">
                        <select
                          aria-label="sortDropdown"
                          onChange={handlefilterChange}
                          name="fliterLevel"
                          value={Filter?.fliterLevel}
                        >
                          <option hidden>Skill Level</option>
                          {courseSortOptionsSkillLevel.map((sort) => (
                            <option key={sort.key} value={sort.value}>
                              {sort.label}
                            </option>
                          ))}
                        </select>
                      </div>

                      {/* <div className="sort-dropdown disabledSelectDropdown">
                      <select
                        aria-label="sortDropdown"
                        onChange={(e) =>
                          handleSortCourses(e.target.value, courses)
                        }
                        disabled={true}
                      >
                        {courseSortOptionsMostRelevant.map((sort) => (
                          <option key={sort.key} value={sort.value}>
                            {sort.label}
                          </option>
                        ))}
                      </select>
                    </div> */}

                      {/* <div className="sort-dropdown disabledSelectDropdown">
                      <select
                        aria-label="sortDropdown"
                        onChange={(e) =>
                          handleSortCourses(e.target.value, courses)
                        }
                        disabled={true}
                      >
                        {courseSortOptionsLearningType.map((sort) => (
                          <option key={sort.key} value={sort.value}>
                            {sort.label}
                          </option>
                        ))}
                      </select>
                    </div> */}

                      {/* <div className="sort-dropdown disabledSelectDropdown">
                      <select
                        aria-label="sortDropdown"
                        onChange={(e) =>
                          handleSortCourses(e.target.value, courses)
                        }
                        disabled={true}
                      >
                        {courseSortOptionsAvailability.map((sort) => (
                          <option key={sort.key} value={sort.value}>
                            {sort.label}
                          </option>
                        ))}
                      </select>
                    </div> */}
                    </div>
                  </div>
                ) : (
                  <Loading />
                )}
              </div>
            </div>
          )}
          <div className="inner-wrapper">
            <div
              className={`content-inner-wrapper ${viewType === "list" ? "list-view" : ""
                }`}
            >
              <div className="sort-column">
                <div className="sort-inner-wrapper">
                  <div className="sort-title">Categories</div>
                </div>
              </div>
              {bundle ? (
                <>
                  {courses.loading ? (
                    <div className="content margin-top-new-40 text-center-courses">
                      <Loading />
                    </div>
                  ) : (
                    <div className="tile-column">
                      {courses?.bundleCourses?.map((post, key) => (
                        <CourseTile
                          post={post}
                          key={key}
                          bundle={bundle}
                          viewType={viewType}
                        />
                      ))}
                    </div>
                  )}
                </>
              ) : (
                <div className="tile-column">
                  {courses?.length > 0
                    ? courses?.map((post, key) => {
                      return (
                        <CourseTile
                          post={post}
                          key={key}
                          viewType={viewType}
                        />
                      );
                    })
                    : courses
                      ?.filter((ele) => ele.Status === 3)
                      ?.map((post, key) => (
                        <CourseTile post={post} key={key} />
                      ))}
                  <div className="content margin-top-new-40 text-center-courses">
                    {courses?.length === 0 && isFetching && (
                      <div className="courses-tile-loader">
                        <Loading />
                      </div>
                    )}
                    {courses?.length === 0 && !isFetching && (
                      <div className="courses-tile-loader">
                        No Courses Found
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
